import { put, call, select, takeLatest } from 'redux-saga/effects';
import {
    GET_AGENCIES_REQUEST,
    getAgenciesSuccess,
    getAgenciesFailure,
    SUBMIT_AGENCY_REQUEST,
    submitAgencySuccess,
    submitAgencyFailure
} from '../actions/agencies';
import { getAgencies, postAgencies, putAgencies } from '../services/agencies';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getCompaniesWorker } from '../../companies/sagas/companies';
import { getCompaniesAccesor } from '../../companies/selectors/companies';
import { getDealersWorker } from '../../dealers/sagas/dealers';
import { getDealersAccesor } from '../../dealers/selectors/dealers';

const getAgenciesAllWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {

        const token = yield select(accessTokenSelector);

        const {
            data: { agencies, total }
        } = yield call(getAgencies, filters, token);


        yield call(getCompaniesWorker);
        yield call(getDealersWorker, { payload: { filters: { limit: 1000 } } });

        const { companies } = yield select(getCompaniesAccesor);
        const { dealers } = yield select(getDealersAccesor);

        yield put(getAgenciesSuccess(agencies, total, companies, dealers));

    } catch (err) {
        yield put(getAgenciesFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitAgencyWorker = function* ({ payload: { agency } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!agency._id) {
            yield call(postAgencies, agency, token);
            yield put(showGlobalError(true, 200, 'created'));
        } else {
            yield call(putAgencies, agency, token);
            yield put(showGlobalError(true, 200, 'updated'));
        }

        yield put(submitAgencySuccess(agency));
    } catch (err) {
        yield put(showGlobalError(true, err));
        yield put(submitAgencyFailure(err));
    }
};

export default [
    takeLatest(GET_AGENCIES_REQUEST, getAgenciesAllWorker),
    takeLatest(SUBMIT_AGENCY_REQUEST, submitAgencyWorker)
];
